// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d4ab1c02","239":"51b967f6","453":"97462893","455":"bdddf33c"}[chunkId] + ".chunk.js";
};